<template>
  <div
    id="pdf-content"
    style="
      width: 100%;
      height: 80%;
      font-family: Arial, sans-serif;
      transform: rotate(90deg);
    "
  >
    <div
      v-for="(item, textIndex) in ui_setting.texts"
      :key="'div1' + textIndex + item.id"
      style="position: absolute; text-align: center"
      :style="
        'left: ' +
        item.x * 1.3 +
        'px ;bottom: ' +
        item.y * 1.1 +
        'px;font-size: ' +
        item.fontSize +
        'pt;' +
        (item.isBold ? 'font-weight: bold;' : '') +
        (item.isUppercase ? 'text-transform: uppercase;' : '') +
        (selectedMBCard&&selectedMBCard.text == item.text ? 'color: blue;' : '')
      "
    >
      <!-- <template v-if="item.text != '%%'">{{ getText(item) }}</template> -->

      <span> {{ getText(item) }} </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  components: {},
  data: () => ({
    ui_setting: {},
  }),
  watch: {},
  props: {
    student: {
      required: true,
      type: Object,
    },
    selectedMBCard: {
      type: Object,
    },
  },
  components: {},
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_settings-ui")
      .doc("diploma-template-ui-page1-mb")
      .onSnapshot((doc) => {
        this.ui_setting = doc.data();
        this.ui_setting.ref = doc.ref;
        this.ui_setting.id = doc.id;
        console.log(this.ui_setting);
      });
  },
  mounted() {
    this.nochange = true;
  },

  methods: {
    _convertToMB(str) {
      if (str) {
        var oldStr = str.toString();
        var newStr = "";
        for (let i = 0; i < oldStr.length; i++) {
          newStr = newStr + this._convertHelper(oldStr[i]);
        }
        return newStr;
      } else {
        return "";
      }
    },
    _convertHelper(char) {
      switch (char) {
        case "1":
          return "᠑";
        case "2":
          return "᠒";
        case "3":
          return "᠓";
        case "4":
          return "᠔";
        case "5":
          return "᠕";
        case "6":
          return "᠖";
        case "7":
          return "᠗";
        case "8":
          return "᠘";
        case "9":
          return "᠙";
        case "0":
          return "᠐";
        default:
          return char;
      }
    },
    getText(text) {
      console.log(this.student);
      if (text.text) {
        var newStr = text.text
          .replaceAll("$$firstName$$", this.student.firstNameMB)
          .replaceAll("$$lastName$$", this.student.lastNameMB)
          .replaceAll("$$curriculumName$$", this.student.xcurriculum.nameMX)
          .replaceAll("$$professionName$$", this.student.xprofession.nameMX)
          .replaceAll(
            "$$curriculumCode$$",
            this._convertToMB(this.student.xcurriculum.curriculumCode)
          );

        return newStr;
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
@media print {
  @page {
    size: landscape;
    margin: 0;
  }

  body {
    margin: 0;
  }
}
.btable {
  border-collapse: collapse;
  border: 1px solid black;
}
.btable th,
td {
  border: 1px solid black;
  padding: 8px;
}

.a4-container {
  position: relative;
  width: 29.7cm;
  height: 21cm;
  border: 1px solid black;
  margin: 0 auto;
}
.a4-container .main-text {
  display: inline-block;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  margin: 0 auto;
  box-sizing: border-box;
}

.a4-container .bottom-container {
  position: relative;
  bottom: 100px;
  display: flex;
  justify-content: space-between;
  height: 100px;

  padding-left: 40px;
  padding-right: 40px;
}

.a4-container .bottom-container .signature {
  border-top: 1px solid black;
  padding-top: 4px !important;
  margin-left: 30px;
  margin-right: 30px;
  width: 33%;
}
.signature .pclass {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.a4-container .head-score-page {
  position: relative;
  top: 10px;
  display: flex;
  justify-content: space-between;
  border: 1px solid black;
}

.a4-container .score-main {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid red;
}
.a4-container .head-score-page .title-column {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .head-score-page .title-column .column-text {
  text-align: left;
  padding: 2px;
  width: 50%;
  background-color: lightgray;
}
.a4-container .score-main .score-table-column {
  padding: 2px;
  width: 30%;
  height: 80%;
  background-color: lightgray;
}
.a4-container .score-signature-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid blue;
}
.a4-container .score-signature-container .score-signature {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 40%;
  background-color: lightgray;
}
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid black;
  padding: 8px;
}
.title-column .upper {
  text-transform: uppercase;
  font-weight: bold;
}
</style>
